var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoCatchup = function SvgIcoCatchup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    fillRule: "evenodd",
    d: "M17.622 2.043a2 2 0 0 0-.973.036l-.663.19-1.607 4.666 1.729-.495zM17.294 6.1l2.412-.692-.557-1.943c-.111-.39-.33-.72-.615-.967zm-4.222-2.995 1.728-.496-1.607 4.667-1.728.495zm-1.186.34-1.73.495L8.55 8.607l1.729-.496zM4.99 5.422l1.066-.306-1.607 4.667-.288.083-.557-1.944a2.02 2.02 0 0 1 1.386-2.5m2.374 3.525-1.73.496 1.608-4.667 1.728-.495zm12.05 4.967h.917v6.065A2.02 2.02 0 0 1 18.31 22H6.18a2.02 2.02 0 0 1-2.02-2.021V9.87h.293l2.831 4.043h1.234l-2.83-4.043h1.798l2.83 4.043h1.234L8.72 9.871h1.798l2.83 4.043h1.235l-2.831-4.043h1.798l2.831 4.043h1.234l-2.831-4.043h1.798zm-1.598-4.043h2.515v3.592z",
    clipRule: "evenodd"
  })));
};
export default SvgIcoCatchup;